import { render, staticRenderFns } from "./practice-overview-mt.vue?vue&type=template&id=1b36bcc2&scoped=true"
import script from "./practice-overview-mt.vue?vue&type=script&lang=js"
export * from "./practice-overview-mt.vue?vue&type=script&lang=js"
import style0 from "./practice-overview-mt.vue?vue&type=style&index=0&id=1b36bcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36bcc2",
  null
  
)

export default component.exports